<mat-card class="compound-filter-control mat-elevation-z2">
  @if (form.get('type')?.value) {
    <div class="card-header-wrapper">
      @if (form.get('type')?.value === 'EXPRESSION') {
        <mat-card-subtitle>
          <span translate>AutomatorCompoundFilterType.EXPRESSION</span>
        </mat-card-subtitle>
      }
      @if (form.get('type')?.value === 'FILTER') {
        <mat-card-subtitle>
          <span translate>AutomatorCompoundFilterType.FILTER</span>
        </mat-card-subtitle>
      }
      <button type="button" mat-button color="warn" (click)="onClearFilter()"><span translate>clear</span></button>
    </div>
  }
  @if (form.get('type')?.value) {
    <mat-card-content [formGroup]="form" class="compound-filter-content">

      @if (form.get('type')?.value === 'FILTER') {
        <ng-container *ngTemplateOutlet="filterControlTemplateRef; context: {form: this.form}"></ng-container>
      }

      @if (form.get('type')?.value === 'EXPRESSION') {
        <ng-container formGroupName="expression">
          <small translate>expressionOperator</small>

          <mat-button-toggle-group formControlName="operator" required class="operator-wrapper" [ngClass]="{ 'operator-invalid': (form.get('expression.operator')?.invalid && form.get('expression.operator')?.touched) }">
            <mat-button-toggle value="AND"><span translate>AutomatorExpressionsOperator.AND</span></mat-button-toggle>
            <mat-button-toggle value="OR"><span translate>AutomatorExpressionsOperator.OR</span></mat-button-toggle>
          </mat-button-toggle-group>

          @for (group of compoundFilters.controls; let i = $index; track $index) {
            <ng-container formArrayName="compoundFilters">
              <app-compound-filter-control
                [level]="+level + 1"
                [formControlName]="i"
                [formSubmitted]="formSubmitted"
                [filterControlTemplateRef]="filterControlTemplateRef"
                [dynamicVariables]="dynamicVariables"
                (remove)="onCompoundFilterRemove(i)">
              </app-compound-filter-control>
              @if (form.get('expression.operator')?.value === 'AND') {
                <div class="operator-divider" translate>AutomatorExpressionsOperator.AND</div>
              }
              @if (form.get('expression.operator')?.value === 'OR') {
                <div class="operator-divider" translate>AutomatorExpressionsOperator.OR</div>
              }
            </ng-container>
          }
        </ng-container>
      }
    </mat-card-content>
  }

  <div class="type-set-wrapper">
    @if (form.get('type')?.value !== 'FILTER' && +level < 3) {
      <button type="button" mat-button (click)="onAddExpression()" class="set-expression-button">
        <mat-icon  >add</mat-icon>
        <span translate>expressionOperator</span>
      </button>
    }
    @if (!form.get('type')?.value) {
      <button type="button" mat-button (click)="onSetFilter()" class="set-filter-button">
        <mat-icon  >filter_alt</mat-icon>
        <span translate>insertFilter</span>
      </button>
    }
    @if (!form.get('type')?.value) {
      <button type="button" mat-button color="warn" class="remove-filter-expression-button" (click)="onRemoveClick()">
        <mat-icon  >remove</mat-icon>
        <span translate>remove</span>
      </button>
    }
  </div>
</mat-card>
